import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { theme } from 'antd';

import {
  EnergySavingChartConfig,
  energySavingChartSeries,
} from '@/comp/pages/ValueDashboardPage/EnergySavings/EnergySavingChartConfig';

import { useStores } from './use-stores';

const { useToken } = theme;

export const useEnergySavings = (animation = true, shouldRestrictEnergySavings = false) => {
  const { t } = useTranslation();
  const { stationStore, energySavingsStore } = useStores();
  const { token } = useToken();
  const [options, setOptions] = useState(null);

  useEffect(() => {
    setOptions(
      !energySavingsStore.isReady
        ? null
        : {
            ...EnergySavingChartConfig(animation, t, energySavingsStore, shouldRestrictEnergySavings, token),
            series: energySavingChartSeries(t, energySavingsStore, shouldRestrictEnergySavings, token),
          },
    );
  }, [energySavingsStore.isReady, energySavingsStore.energySavings, animation, token]);

  useEffect(() => {
    const currentYear = moment().year();
    energySavingsStore.setRequestedYear(currentYear);
  }, [stationStore.currentStation]);

  return { options };
};
